export var all_status = ['completed', 'not_approved', 'no_status', 'missing', 'reviewing', 'pending_receipt', 'pending_verification'];